import _default from './Segment';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Segment/index.js
// module id = 2714
// module chunks = 1